module.exports = __webpack_public_path__ + "asset/image/ic_visa-2a76.svg";